import queryString from "query-string";

export function parse(search: string) {
  return queryString.parse(search, { arrayFormat: "none" });
}

export function stringify(
  params: Record<string, unknown> | Array<[string, unknown]>,
) {
  return queryString.stringify(params, { arrayFormat: "none" });
}
